import CommonService from "./common.service";

const BASE = "/support";

export const supportDisputeExtractMessage = (err, fallback = "Request failed") =>
  err?.response?.data?.message || err?.response?.data?.error || err?.message || fallback;

export const fetchMyAssignedDisputes = async (params = {}) => {
  const res = await CommonService.get(`${BASE}/disputes`, params, { silent: true });
  return res?.data ?? { items: [], total: 0, page: 1, pageSize: 20 };
};

export const fetchMyAssignedDisputeStats = async () => {
  const res = await CommonService.get(`${BASE}/disputes/stats`, {}, { silent: true });
  return (
    res?.data ?? {
      total: 0,
      inProgress: 0,
      resolved: 0,
      closed: 0,
    }
  );
};

export const fetchMyAssignedDisputeById = async (id) => {
  const res = await CommonService.get(`${BASE}/disputes/${id}`, {}, { silent: true });
  return res?.data ?? null;
};

export const updateMyAssignedDisputeStatus = async (id, payload) => {
  const res = await CommonService.patch(`${BASE}/disputes/${id}/status`, payload, { silent: true });
  return res?.data?.dispute ?? null;
};

export const fetchMyDisputeMessages = async (id) => {
  const res = await CommonService.get(`${BASE}/disputes/${id}/messages`, {}, { silent: true });
  return res?.data?.messages ?? [];
};

export const postMyDisputeMessage = async (id, { message, isInternal, attachment }) => {
  const form = new FormData();
  form.append("message", message || "");
  form.append("isInternal", isInternal ? "true" : "false");
  if (attachment) form.append("attachment", attachment);
  const res = await CommonService.post(`${BASE}/disputes/${id}/messages`, form, { silent: true });
  return res?.data?.message ?? null;
};

export const SUPPORT_STATUS_OPTIONS = [
  { value: "assigned", label: "Assigned" },
  { value: "in_progress", label: "In Progress" },
  { value: "waiting_buyer", label: "Waiting for Buyer Response" },
  { value: "waiting_seller", label: "Waiting for Seller Response" },
  { value: "under_investigation", label: "Under Investigation" },
  { value: "resolved", label: "Resolved" },
  { value: "closed", label: "Closed" },
  { value: "reopened", label: "Reopened" },
];

export const SUPPORT_PRIORITY_OPTIONS = [
  { value: "Low", label: "Low" },
  { value: "Medium", label: "Medium" },
  { value: "High", label: "High" },
  { value: "Urgent", label: "Critical / Urgent" },
  { value: "Critical", label: "Critical" },
];
